import { Icon } from "ui-kit";
import { Typography } from "ui-kit/Typography";
import { useWebTranslation } from "translations";
import styles from "./SavingsBanner.module.css";
import Colors from "ui-kit/colors";
import { useTotalCost } from "components/Signup/store/selectors/animals";
import { formatCurrency } from "utils/utils";

export function SavingsBanner() {
  const { t } = useWebTranslation();

  const totalCost = useTotalCost();

  if (!totalCost.old) {
    return null;
  }

  return (
    <div className={styles.container}>
      <Icon name="checkmark-badge-fill" size="S" color={Colors.green300} />
      <div className={styles.textContainer}>
        <Typography variant="body3">
          <strong>
            {t("savingsbanner.title", {
              savings: formatCurrency(totalCost.old - totalCost.new),
            })}
          </strong>
        </Typography>
      </div>
    </div>
  );
}
